// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const HttpEndpointSource = {
    proto: (value) => {
        return Object.assign(Object.assign({}, value), { type: "proto", _visit: function (visitor) {
                return FernIr.HttpEndpointSource._visit(this, visitor);
            } });
    },
    openapi: () => {
        return {
            type: "openapi",
            _visit: function (visitor) {
                return FernIr.HttpEndpointSource._visit(this, visitor);
            },
        };
    },
    openrpc: () => {
        return {
            type: "openrpc",
            _visit: function (visitor) {
                return FernIr.HttpEndpointSource._visit(this, visitor);
            },
        };
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "proto":
                return visitor.proto(value);
            case "openapi":
                return visitor.openapi();
            case "openrpc":
                return visitor.openrpc();
            default:
                return visitor._other(value);
        }
    },
};
